import { Component, OnInit, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl,
         Sort, PageEvent, MatExpansionModule } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';
import { VendorComplaintsService } from '../../services/vendor-complaints/vendor-complaints.service';

@Component({
  selector: 'app-vendor-complaint-documents',
  templateUrl: './vendor-complaint-documents.component.html',
  styleUrls: ['./vendor-complaint-documents.component.css']
})
export class VendorComplaintDocumentsComponent implements OnInit {
  displayedColumns = ['DocumentName', 'UpdatedTimeStamp'];
  dataSource: MatTableDataSource<ViewDocsData>;
  public docsList: any;
  length: any;
  ispaginationFlag: boolean = false;
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageEvent: PageEvent;
  pageSize = 10;
  message: string;
  errorMessage: string = '';
  errorEnable: boolean = false;
  signedUrl;

  constructor(public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<VendorComplaintDocumentsComponent>,
              public complaintService: VendorComplaintsService) { }

  ngOnInit() {
    this.getComplaintDocs(this.data.ComplaintId, this.data.MasterVendorId);
    this.refreshList();
  }

  refreshList(){
    this.complaintService.load.subscribe(res=>{
      if(res === "success"){
        this.getComplaintDocs(this.data.ComplaintId, this.data.MasterVendorId);
      }
    });
  }

  getComplaintDocs(complaintId, masterVendorId) {
    this.docsList = [];
    this.complaintService.getVendorComplaintDocs(complaintId, masterVendorId).subscribe(res => {
      if (res.ComplaintDocs.length <= 0) {
        this.docsList = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No Documents are available for the Complaint";
      } else {
        this.message = '';
        this.docsList = res.ComplaintDocs;
        for (let i = 0; i < this.docsList.length; i++) {
          if (this.docsList[i].UpdatedTimeStamp) {
            this.docsList[i].UpdatedTimeStamp = moment(this.docsList[i].UpdatedTimeStamp).format('MM/DD/YYYY');
          }
        }
        this.dataSource = new MatTableDataSource(this.docsList);
        this.dataSource.sort = this.sort;
        this.length = this.docsList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) {
            return `0 van ${length}`;
          }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        };
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.errorMessage = "View Documents Service : " + err;
      this.errorEnable = true;
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }
}

export interface ViewDocsData {
  "DocumentName": String;
  "UpdatedTimeStamp": Date;
}



// WEBPACK FOOTER //
// ./src/app/components/vendor-complaint-documents/vendor-complaint-documents.component.ts